import { useMemo } from 'react';

import { getFilterOptions } from '../../../helpers/filter';

import { RULE_PRIORITY } from '../../../constants/rule';

export const useFilterOptions = data => {
  return useMemo(() => {
    if (!Array.isArray(data) || data.length === 0) {
      return {
        priorities: [],
        statuses: [],
        types: []
      };
    }

    return {
      priorities: [...new Set(data?.map(item => item.data).map(d => d.action?.value))].map(p => ({
        text: RULE_PRIORITY[p],
        value: p
      })),
      statuses: getFilterOptions(data, 'snooze_status'),
      types: getFilterOptions(data, 'type_display_name')
    };
  }, [data]);
};
